import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

const useGreetCategoryKlydoStatsQuery = (category: string) => {
  return useQuery({
    queryKey: ["greet-category-klydo-stats", category],
    queryFn: () => adminApiClient.getGreetCategoryKlydoStats(category),
    enabled: !!category,
  });
};

export default useGreetCategoryKlydoStatsQuery;
